<ng-content select="glxy-nav-header" />

<div class="glxy-nav-panel-contents">
  <ng-content />
</div>

<ng-content select="glxy-nav-footer" />
